import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet'
import Header from '../../Molecules/Header/Header'
import Footer from '../../Molecules/Footer/Footer'

const Disclaimer = () => {
    useEffect(() => {
        // 👇️ scroll to top on page load
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }, []);


    return (
        <>
            <Helmet>
                <link rel="canonical" href="https://www.wisefunds.com/disclaimer" />
            </Helmet>
            <Header />
            <div className="about">
                < div class="four" >
                    <h3>Disclaimer</h3>
                </div >
                <div className="privacy-body">
                    <p>Wise Funds team has, to the best of its ability, taken into account various factors – both quantitative measures and qualitative assessments, in an unbiased manner, while advising the fund(s). However, they carry unknown risks and uncertainties linked to broad markets, as well as analysts’ expectations about future events. They shoudn't, therefore, be the sole basis of investment decisions.The recommendations and reviews do not guarantee fund performance, nor should they be viewed as an assessment of a fund’s, or the fund’s underlying securities’ creditworthiness.</p>

                    <p>Mutual fund investments are subject to market risks. Please read the scheme information and other related documents before investing. Past performance is not indicative of future returns. Please consider your specific investment requirements before choosing a fund, or designing a portfolio that suits your needs. Wise Funds (ARN-173708) makes no warranties or representations, express or implied, on products offered through the platform. It accepts no liability for any damages or losses, however caused, in connection with the use of, or on the reliance of its product or related services.</p>

                </div>
            </div>
            <Footer />
        </>
    )
}

export default Disclaimer
